import { useState, useEffect } from "react";
import { useMap } from '@mantine/hooks';
import { Box, Group, Loader, Stack, Text, Divider } from "@mantine/core";
import { PrettyKey } from "@/strings.fn";
import { useResults } from "../contexts/results.ctx";

export interface TesteeDetailsProps {
    testID: string;
}

export default function TesteeDetails({ testID }: TesteeDetailsProps) {
    const { getResultIntakeAnswers } = useResults();
    const testeeInfoMap = useMap<string, string | number | boolean>();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (loading) return;
        setLoading(true);
        getResultIntakeAnswers(testID)
            .then((data: { info: Record<string, string | number | boolean> }) => {
                Object.entries(data.info).forEach(([key, value]) => {
                    testeeInfoMap.set(key, value);
                });
            })
            .finally(() => {
                setLoading(false);
            });
    }, [testID]);

    if (loading) return <Loader />;

    return (<Box>
        <Stack justify="center">
            <Text size='1.3rem' fw={500} ta={'center'}>Details & Exit Questions</Text>
            <Divider my={'sm'} />
            {Array.from(testeeInfoMap).map(([key, value], dex) => {
                if(key === 'mustSell'){
                    key = 'hasObligations'
                }
                if( typeof value === 'boolean' ){
                    value = value ? 'Yes' : 'No';
                }
                return (
                    <Group wrap="nowrap" mx={'20%'} justify="space-between" key={`${key}-${dex}`}>
                        <Text fw={400} size="1.1rem" c={'dimmed'}>{PrettyKey(key)}</Text>
                        <Text fw={600} size='1.2rem' >{value}</Text>
                    </Group>
                )
            })}
        </Stack>
    </Box>)


}